import axios from 'axios';
import { API_URL, getCachedSessionId } from '../../services/common';

export default axios.create({
  baseURL: `${API_URL}/v1/project/`,
  headers: { 'x-session-id': getCachedSessionId() }
});
